import {FC} from "react";
import {Table} from "semantic-ui-react";
import {
    IColumnMetadata,
    ICustomColumnsTransformation,
    IDataTableData
} from "../../features/application/api/applicationModels";
import DataTableRow from "./DataTableRow";

interface IDataTableBodyProps {
    data: IDataTableData[];
    staticColumns: IColumnMetadata[];
    customColumns: ICustomColumnsTransformation;
    configurableColumns?: IColumnMetadata[];
    currentIndex: number;
    itemsPerPage: number;
    isMobileScreen: boolean;
    renderDetailBody?:
        | ((data: IDataTableData, isMobileScreen: boolean) => JSX.Element)
        | undefined
        | null;
}
const DataTableBody: FC<IDataTableBodyProps> = ({
    data,
    staticColumns,
    customColumns,
    configurableColumns,
    currentIndex,
    itemsPerPage,
    isMobileScreen,
    renderDetailBody
}) => {
    return (
        <Table.Body>
            {data
                .slice(currentIndex, currentIndex + itemsPerPage)
                .map((row, rowIndex) => (
                    <DataTableRow
                        key={"DataTableRow" + rowIndex}
                        customColumns={customColumns}
                        data={row}
                        isMobileScreen={isMobileScreen}
                        rowIndex={rowIndex}
                        staticColumns={staticColumns}
                        configurableColumns={configurableColumns}
                        renderDetailBody={renderDetailBody}
                    />
                ))}
        </Table.Body>
    );
};

export default DataTableBody;
